import { AdvancedFilterOption } from "../FilterSelectionDialog/FilterSelectionDialog";

export const ADVANCED_FILTER_OPTIONS: AdvancedFilterOption[] = [
  { id: "financial", label: "Financial" },
  { id: "status", label: "Status" },
  { id: "birthMonth", label: "Birth Month" },
  { id: "gender", label: "Gender" },
  { id: "memberLevel", label: "Member Level ID" },
  { id: "memberLevelDescription", label: "Member Level" },
  { id: "membershipType", label: "Membership Type ID" },
  { id: "membershipTypeDescription", label: "Membership Type" },
  { id: "pointsBalanceEqualTo", label: "Points Balance Equal To" },
  { id: "pointsBalanceNotEqualTo", label: "Points Balance Not Equal To" },
  { id: "pointsBalanceGreaterThan", label: "Points Balance Greater Than" },
  { id: "pointsBalanceLessThan", label: "Points Balance Less Than" },
  {
    id: "pointsBalanceGreaterThanOrEqualTo",
    label: "Points Balance >= ",
  },
  { id: "pointsBalanceLessThanOrEqualTo", label: "Points Balance <=" },
];

export interface FilterValue {
  financial?: boolean | null;
  status?: string[];
  excludeStatus?: string[];
  birthMonth?: string[];
  excludeBirthMonth?: string[];
  gender?: string[];
  excludeGender?: string[];
  memberLevel?: string[];
  excludeMemberLevel?: string[];
  memberLevelDescription?: string[];
  excludeMemberLevelDescription?: string[];
  membershipType?: string[];
  excludeMembershipType?: string[];
  membershipTypeDescription?: string[];
  excludeMembershipTypeDescription?: string[];
  pointsBalanceEqualTo?: number;
  pointsBalanceNotEqualTo?: number;
  pointsBalanceGreaterThan?: number;
  pointsBalanceLessThan?: number;
  pointsBalanceGreaterThanOrEqualTo?: number;
  pointsBalanceLessThanOrEqualTo?: number;
}

export const getLocalStorageKey = (businessId: string) =>
  `cherry-pay-pinned-filters-${businessId}`;

export const getSessionStorageKey = (businessId: string) =>
  `cherry-pay-filter-values-${businessId}`;

export const loadPinnedFilters = (businessId: string): Set<string> => {
  try {
    const stored = localStorage.getItem(getLocalStorageKey(businessId));
    return stored ? new Set(JSON.parse(stored)) : new Set();
  } catch {
    return new Set();
  }
};

export const savePinnedFilters = (
  businessId: string,
  pinnedFilters: Set<string>
) => {
  try {
    localStorage.setItem(
      getLocalStorageKey(businessId),
      JSON.stringify(Array.from(pinnedFilters))
    );
  } catch (error) {
    console.error("Failed to save pinned filters:", error);
  }
};

export const loadFilterValues = (businessId: string): any => {
  try {
    const stored = sessionStorage.getItem(getSessionStorageKey(businessId));
    return stored ? JSON.parse(stored) : {};
  } catch {
    return {};
  }
};

export const saveFilterValues = (businessId: string, filterValues: any) => {
  try {
    sessionStorage.setItem(
      getSessionStorageKey(businessId),
      JSON.stringify(filterValues)
    );
  } catch (error) {
    console.error("Failed to save filter values:", error);
  }
};
